<template>
  <div>
    <h2 class="content-block">Practice Chart Doughnut</h2>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <div>
          <div class="pies-container">
            <!-- <DxPieChart
              title="belajar"
              id="pie-chart2"
              :data-source="fetchData"
              :inner-radius="0.65"
              resolve-label-overlapping="shift"
              size-group="piesGroup"
              type="doughnut"
              center-template="centerTemplate"
              palette="Harmony Light"
              palette-extension-mode="blend"
            >
              <DxSeries argument-field="pegawai_status_id" value-field="total">
             
                <DxLabel
                  :visible="true"
                  :customize-text="customizeLabel"
                  position="columns"
                >
                  <DxConnector :visible="true" :width="0.5" />
                  <DxFont :size="16" />
                </DxLabel>
              </DxSeries>
              <DxLegend
                :visible="true"
                :margin="0"
                horizontal-alignment="center"
                vertical-alignment="bottom"
                :customize-items="customizeLegend"
                hover-mode="allArgumentPoints"
              />
              <template #centerTemplate="data">
                <CenterTemplate :pie-chart="data.data" />
              </template>
              <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip">
                <DxFormat type="millions" />
              </DxTooltip>
            </DxPieChart> -->
          </div>
        </div>

        <div>
          <div class="long-title"><h3>Energy Production (GWh, 2016)</h3></div>
          <div class="pies-container">
            <DxPieChart
              id="pie-chart"
              :data-source="fetchData"
              :inner-radius="0.65"
              resolve-label-overlapping="shift"
              size-group="piesGroup"
              type="doughnut"
              center-template="centerTemplate"
              palette="Harmony Light"
              palette-extension-mode="blend"
            >
              <!-- :palette="['#60a69f', '#78b6d9', '#6682bb', '#a37182', '#eeba69']"> -->
              <DxSeries argument-field="nama" value-field="total">
                <!-- <DxLabel
                  :visible="true"
                  background-color="none"
                  format="fixedPoint"
                  :customize-text="customizeLabel"
                >
                  <DxConnector :visible="true" />
                </DxLabel> -->
                <DxLabel
                  :visible="true"
                  :customize-text="customizeLabel"
                  position="columns"
                >
                  <DxConnector :visible="true" :width="0.5" />
                  <DxFont :size="16" />
                </DxLabel>
              </DxSeries>
              <DxLegend
                :visible="true"
                :margin="0"
                horizontal-alignment="center"
                vertical-alignment="bottom"
                :customize-items="customizeLegend"
                hover-mode="allArgumentPoints"
              />
              <template #centerTemplate="data">
                {{ printHelper(data.data) }}
                <CenterTemplate :pie-chart="data.data" />
              </template>
              <DxTooltip :enabled="true" :customize-tooltip="customizeTooltip">
                <DxFormat type="millions" />
              </DxTooltip>
            </DxPieChart>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  DxPieChart,
  DxSeries,
  DxTooltip,
  DxLegend,
  DxLabel,
  DxConnector,
} from "devextreme-vue/pie-chart";
import { dataSource } from "./practice-chart-doughnut-data.js";
import CenterTemplate from "./CenterTemplate.vue";
import axios from "axios";

export default {
  components: {
    DxPieChart,
    DxSeries,
    DxTooltip,
    DxLegend,
    DxLabel,
    DxConnector,
    CenterTemplate,
  },
  data() {
    return {
      fetchData: null,
      dataSource,

      // countries: Array.from(new Set(dataSource.map((item) => item.country))),
    };
  },
  async mounted() {
    this.fetchData = await this.fetchDataMethod();
    console.log("fetchData", this.fetchData);
  },
  methods: {
    printHelper(val) {
      console.log("printHelper", val);
    },
    async fetchDataMethod() {
      try {
        const response = await axios.get(
          "http://127.0.0.1/api/rangkuman_dashboard_chart"
        );
        console.log("fetchDataMethod", response.data.pegawaiStatus);
        return response.data.pegawaiStatus;
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    },
    customizeLabel(argumentText) {
      // return "";
      // return `${argumentText}\n${valueText}`;
      // console.log("label", argumentText);
      console.log("customizeLabel", argumentText);
      return `${argumentText.valueText} (${argumentText.percentText})`;
    },
    getData() {
      console.log("getData ", dataSource);
      return dataSource;
      // return dataSource.filter((i) => i.country === country);
    },
    // customizeTooltip({ valueText, percent }) {
    //   console.log("tooltip", percent);
    //   return {
    //     text: `${valueText} - ${(percent * 100).toFixed(2)}%`,
    //   };
    // },
    customizeTooltip({ argument, valueText, percent }) {
      return {
        text: `${argument} - ${valueText} (${(percent * 100).toFixed(2)}%)`,
      };
    },

    // customizeTooltip(e) {
    //   console.log("tooltip", e);
    //   return `${e.argument} - ${e.valueText} (${e.percentText})`;
    // },
  },
};
</script>
<style scoped>
.pies-container {
  margin: auto;
  width: 800px;
}

.pies-container > div {
  width: 400px;
  float: left;
  margin-top: -50px;
}

.long-title h3 {
  font-weight: 200;
  font-size: 28px;
  text-align: center;
  margin-bottom: 20px;
}
</style>
